<script >
	

</script>


<div class="poweredByContainer">

	<div class="poweredByTextContainer">

		<div class="poweredByText">
			Powered By
		</div>
		
	</div>

	<div class="poweredByLogosContainer">

		<div class="logo fsqa"></div>
		<div class="logo cimo"></div>
		<div class="logo ipb"></div>
		<div class="logo prima"></div>
		
	</div>



</div>

<style >
	


@media only screen and (min-width: 768px){

	.poweredByContainer{
			width: 100%;
			height:100%;
			display: flex;
			flex-direction: column;
			float: right;
	}

	.poweredByTextContainer{
		width: 100%;
		height: 30%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 2%;
		/*background-color: red;*/
	}

	.poweredByText{
		width: 100%;
		height: 100%;
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		font-style: normal;
		font-weight: 700;
		font-size: 1.2vw;
		text-transform: uppercase;
		opacity: 0.8;
	}


	.poweredByLogosContainer{
		width: 100%;
		height: 70%;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-evenly;
		margin-top: 2%;
		gap: 25%;
		/*background-color: white;*/
	}

	.logo{
		background-color: transparent;
	}

	.fsqa{
		width:83px;
		height: 50px;
		background-image: url('/img/logos/fsqa_logo.png');
		background-repeat: no-repeat;
		background-size: cover;
	}
	.artisane{
		width:65px;
		height: 50px;
		background-image: url('/img/logos/artisane_white.png');
		background-repeat: no-repeat;
		background-size: cover;
	}

	.cimo{
		width:137px;
		height: 50px;
		background-image: url('/img/logos/cimo_logo.png');
		background-repeat: no-repeat;
		background-size: cover;
	}

	.ipb{
		width:193px;
		height: 50px;
		background-image: url('/img/logos/ipb.png');
		background-repeat: no-repeat;
		background-size: cover;
	}

	.prima{
		width:161px;
		height: 50px;
		background-image: url('/img/logos/prima_logo.png');
		background-repeat: no-repeat;
		background-size: cover;
	}
}


</style>
